import { useQuery } from "react-query";
import { apiQuery } from "common/api";

export const useApiQuery = (key, api, type, params) => {
  return useQuery([key], () => apiQuery(api, type, params));
};
